<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-cogs"></em> Configuration</h1>
			</div>
		</div>

		<div class="row mb-5">
			<div class="col-12 col-md-6 col-lg-2" v-if="typeof config[0] != 'undefined'">
				<div class="card mb-4">
					<div class="card-header"><b>School Year</b></div>

					<div class="card-body">
						<form @submit.prevent="save(0)">
							<div class="mb-3">
								<input type="number" v-model="config[0].config_value" class="form-control form-control-sm" :min="new Date().getFullYear() - 1" step="1" required />
							</div>

							<div class="text-center">
								<button type="submit" class="btn btn-sm btn-primary"><em class="fas fa-save"></em> Save</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-5" v-if="typeof config[2] != 'undefined'">
				<div class="card mb-4">
					<div class="card-header"><b>First Day of School</b></div>

					<div class="card-body">
						<form @submit.prevent="save(2)">
							<div class="mb-3">
								<nv-date v-model="config[2].config_value" :key="config[2].config_value" :small="true" />
							</div>

							<div class="text-center">
								<button type="submit" class="btn btn-sm btn-primary"><em class="fas fa-save"></em> Save</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-5" v-if="typeof config[1] != 'undefined'">
				<div class="card mb-4">
					<div class="card-header"><b>Available Address Change Dates</b></div>

					<div class="card-body">
						<form @submit.prevent="save(1)">
							<div class="mb-3">
								<div v-for="(d, index) in config[1].config_value" :key="index" class="form-row mb-2">
									<div class="col-11"><nv-date v-model="config[1].config_value[index]" :key="config[1].config_value[index]" :small="true" /></div>
									<div class="col-1"><button type="button" class="btn btn-sm btn-secondary mr-1" @click="removeDate(index)"><em class="fas fa-minus-circle"></em></button></div>
								</div>
							</div>

							<div class="text-center">
								<button type="button" class="btn btn-sm btn-secondary mr-1" @click="addDate()"><em class="fas fa-plus-circle"></em> Add Date</button>
								<button type="submit" class="btn btn-sm btn-primary ml-1"><em class="fas fa-save"></em> Save</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import nvDate from "@/components/nvDate";

	export default {
		name: 'User',
		props: ["session_id", "logged_in", "current_user"],
		components: {
			nvDate
		},
		data() {
			return {
				config: []
			}
		},
		mounted: function()
		{
			if(!this.logged_in)
			{
				return;
			}

			this.load();
		},
		methods:
		{
			load: function()
			{
				var vm = this;

				vm.startLoading();

				this.CORS('GET', "/registration/config", null,
					function(data)
					{
						vm.populate(data);
						vm.stopLoading();
					}, function()
					{
						vm.stopLoading();
						vm.showError("Error", "Error loading configuration.", true, null);
					});
			},
			populate: function(data)
			{
				data[0].config_value = Number(data[0].config_value);
				data[1].config_value = JSON.parse(data[1].config_value);

				this.config = data;
			},
			save: function(index)
			{
				var vm = this;

				vm.startLoading();

				this.CORS("PUT", "/registration/config/" + vm.config[index].config_id, JSON.stringify(vm.config[index]),
					function(data)
					{
						console.debug(data[1]);
						vm.populate(data);
						vm.stopLoading();
					}, function(response)
					{
						vm.stopLoading();
						vm.showError("Error", "Error saving configuration value: " + response.responseText, true, null);
					});
			},
			addDate: function()
			{
				this.config[1].config_value.push("");
			},
			removeDate: function(index)
			{
				this.config[1].config_value.splice(index, 1)
			}
		}
	}
</script>
